export enum BenefitsStatuses {
    Published = 'Published',
    Draft = 'Draft'
}
